import { FC, useState } from 'react'
import { SiteModel } from '../../../core/_models'
type Props = {
    site: SiteModel
}
const ProjectType: FC<Props> = ({ site }) => (

    <div className='d-flex align-items-center'>
        {site.projectType}
    </div>

)
export { ProjectType }
